import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  UPDATED,
  CREATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE
} from './actionTypes'

export const fetchList = (tenantId, params) => ({
  type: FETCH_LIST,
  payload: {
    tenantId,
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const created = data => ({
  type: CREATED,
  payload: data
})

export const setActiveState = (id, isActive, onSuccess) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive, onSuccess }
})
